module.exports = __webpack_public_path__ + "2a06a49a55303aaed2a744ab0f94aa6f.jpg";